import { get, post, put } from "./api_helper"

// branches
const getListPage = params => get('admin/master/dimension/page', params)
const getDetail = (id) => get(`admin/master/dimension/${id}`)
const putData = params => put(`admin/master/dimension/${params.id}`, params)
const postData = params => post(`admin/master/dimension`, params)
const getList = (params) => get(`admin/master/dimension/list`, params)
const getFrameType = () => get(`admin/master/dimension/frame-type`)
const getDimensionProductCategory = () => get(`admin/master/dimension/dimension-product-category`)


const DimensionAPI = {
  getListPage,
  getDetail,
  postData,
  putData,
  getList,
  getFrameType,
  getDimensionProductCategory
}

export default DimensionAPI